<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <vx-card class="sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4 full-page-bg-color">
        <div slot="no-body" class="flex flex-row">
          <div class="hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
            <img src="@/assets/images/pages/maintenance-2.png" alt="graphic-maintenance" class="mx-auto mb-4">
          </div>

          <div class="sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
            <div class="px-8 pt-8 register-tabs-container">
              <div class="vx-card__title mb-4">
                <h5 class="sm:mx-0 mx-4 mb-6 text-5xl d-theme-heading-color">
                  {{ $t('pages.login.redirect.title') }}
                </h5>

                <div class="w-full flex justify-end pt-6">
                  <vs-button color="primary" :to="{ name: 'login' }">
                    {{ $t('buttons.login') }}
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
  </div>
</template>

<script>
import NotificationService from "@/services/Notification.service";
import { showErrorNotify } from "@/helpers/functionsHelpers";

export default {
  components: {
  },
  data() {
    return {
      verified: false,
    }
  },
  computed: {
  },
  methods: {
    submit() {
      if (this.$route.path === '/notification/pagseguro') {
        if (this.$route.query.code) {
          const code = this.$route.query.code;
          NotificationService.pagseguroNotify(code).then((response) => {
            console.log('NOTIFY', response);
            this.$router.push({name: 'login'});
          }, error => {
            showErrorNotify(this, error);
          });
        }
      } else if (this.$route.path === '/notification/paypal') {
        if (this.$route.query.token) {
          const token = this.$route.query.token;
          NotificationService.paypalNotify(token).then((response) => {
            console.log('NOTIFY', response);
            this.$router.push({name: 'cases-new'});
          }, error => {
            showErrorNotify(this, error);
          });
        }
      } else {
        this.$router.push({name: 'login'});
      }
    }
  },
  mounted() {
    this.submit();
  }
}
</script>
